import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { browserTracingIntegration } from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import '../src/app/core/extensions';

if (!location.origin.includes('localhost')) {
  // Base Sentry configuration
  const sentryConfig = {
    dsn: environment.dsn,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ZoneImpl.run',
      'captureException',
      '<unknown>',
      'Canceled',
      'Canceled: Canceled',
    ],
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: [environment.appUrl, environment.apiUrl],
    release: environment.version.replace('v', 'ver-'),
    sendClientReports: false,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0
  };

  Sentry.init(sentryConfig);
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
